import { Button, EmptyState, Loading, Modal, Tag } from "../../ui";
import AbroadHistory from "../../abroadLoans/AbroadHistory";
import { useMyAbroadApplication } from "../../abroadLoans/student";
import StatusTracker from "./StatusTracker";
import { studentStatusOf, useMyApplication } from "./model";

function ScholarshipProgress({ id }) {
  const { data, isPending, isError, refetch } = useMyApplication(id);
  if (isPending) return <Loading label="Loading the progress…" />;
  if (isError) return <EmptyState title="Could not load the progress" onRefresh={refetch} />;
  return <StatusTracker application={data.data} />;
}

function AbroadProgress({ id }) {
  const { data, isPending, isError, refetch } = useMyAbroadApplication(id);
  if (isPending) return <Loading label="Loading the progress…" />;
  if (isError) return <EmptyState title="Could not load the progress" onRefresh={refetch} />;
  return <AbroadHistory history={data.history} />;
}

/**
 * Where one of the student's applications is: a scholarship's whole path, or an abroad loan's
 * history. `row` is a row of the applications table: { id, name, studentStatus, abroad }.
 */
export default function ProgressDialog({ row, onClose }) {
  const status = studentStatusOf(row.studentStatus);
  return (
    <Modal
      open
      onClose={onClose}
      size="xl"
      title={row.name}
      description={row.programme}
      footer={
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2 text-sm text-slate-600">
          <Tag color={status.color}>{status.label}</Tag>
          {status.hint}
        </div>
        {row.abroad ? <AbroadProgress id={row.id} /> : <ScholarshipProgress id={row.id} />}
      </div>
    </Modal>
  );
}
